import React from 'react';
import { Tag, Tooltip, Typography } from 'antd';
import dayjs from 'dayjs';
import useTenantFlags from 'hooks/useTenantFlags';

const { Text } = Typography;

// Badge para mostrar el estado de una certificación a partir de su
// fecha_vencimiento. Umbrales alineados con la Fase 3 del plan regulatorio:
// - vencida (ayer o antes): rojo
// - crítica (vence en <= 7 días): rojo
// - advertencia (vence en 8-30 días): naranja
// - vigente (> 30 días): verde
//
// Props:
// - fecha: string YYYY-MM-DD o Date o dayjs. Requerido.
// - size: 'sm' | 'md' (default 'md')

function getConfig(fecha) {
  if (!fecha) return null;
  const target = dayjs(fecha);
  if (!target.isValid()) return null;
  const diasRestantes = target.startOf('day').diff(dayjs().startOf('day'), 'day');

  if (diasRestantes < 0) {
    return {
      color: 'red',
      label: `Vencida (${Math.abs(diasRestantes)}d)`,
      tooltip: `Venció el ${target.format('DD/MM/YYYY')}`,
    };
  }
  if (diasRestantes <= 7) {
    return {
      color: 'red',
      label: `Vence en ${diasRestantes}d`,
      tooltip: `Vencimiento crítico — ${target.format('DD/MM/YYYY')}`,
    };
  }
  if (diasRestantes <= 30) {
    return {
      color: 'orange',
      label: `Vence en ${diasRestantes}d`,
      tooltip: `Vencimiento próximo — ${target.format('DD/MM/YYYY')}`,
    };
  }
  return {
    color: 'green',
    label: target.format('DD/MM/YYYY'),
    tooltip: `Vigente — vence el ${target.format('DD/MM/YYYY')}`,
  };
}

function CertificacionBadge({ fecha, size = 'md' }) {
  const { minvuEnabled } = useTenantFlags();
  if (!minvuEnabled) return null;

  const config = getConfig(fecha);
  if (!config) return <Text type="secondary">—</Text>;

  return (
    <Tooltip title={config.tooltip}>
      <Tag
        color={config.color}
        style={{
          margin: 0,
          fontSize: size === 'sm' ? 11 : 12,
          fontWeight: 600,
          padding: size === 'sm' ? '1px 8px' : '2px 10px',
        }}
      >
        {config.label}
      </Tag>
    </Tooltip>
  );
}

export default CertificacionBadge;
